import { CreateAddressButtonContainer } from '@/containers/SubscriptionFormPageNew/Components/Address/styled-components'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import useAddAddressButton from './useAddAddressButton'

const AddAddressButton = () => {
  const { t, hidden, isPulse, buttonKind, buttonOverrides, onAddAddress } = useAddAddressButton()

  if (hidden) {
    return null
  }

  return (
    <CreateAddressButtonContainer $pulse={isPulse}>
      <SDButton onClick={onAddAddress} kind={buttonKind} overrides={buttonOverrides}>
        {t('subscriptionForm:address_v2.new_address_title')}
      </SDButton>
    </CreateAddressButtonContainer>
  )
}

export default AddAddressButton
